import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated results list.
 *
 * All behaviour (infinite scroll / pagination) lives in PaginatedList. The grid layout is fixed
 * (2-up mobile, 4-up desktop); the density/zoom-out switcher this element used to drive was removed.
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('initialized', '');
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
